<template>
  <v-container fluid>
    <v-row>
      <!-- بخش راهنما -->
      <v-col cols="12">
        <help-info-wrapper
          :info.sync="helpData"
          :service-name="serviceName"
          class="warp"
        >
          <template>
            <div>
              <v-row v-if="value" no-gutters>
                <!-- فیلد عنوان -->
                <v-col class="py-2" cols="12">
                  <div class="rowinfo">
                    <v-text-field
                      v-model="computedValue.title"
                      append-icon="mdi-form-textbox"
                      class="rounded-lg contentinfo"
                      clearable
                      dense
                      hide-details
                      :label="$t('title')"
                      outlined
                    />
                    <help-info
                      :element-name="`${serviceName}-${componentName}-computedValue-title`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      :label="$t('title')"
                    />
                  </div>
                </v-col>

                <!-- فیلد توضیحات -->
                <v-col class="py-2" cols="12">
                  <div class="rowinfo">
                    <v-textarea
                      v-model="computedValue.description"
                      append-icon="mdi-text"
                      class="rounded-lg contentinfo"
                      clearable
                      dense
                      hide-details
                      :label="$t('description')"
                      outlined
                    />
                    <help-info
                      :element-name="`${serviceName}-${componentName}-computedValue-description`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      :label="$t('description')"
                    />
                  </div>
                </v-col>

                <!-- ================= تنظیمات ارسال پیامک ================= -->

                <!-- سوییچ اصلی ارسال پیامک -->
                <v-col cols="12" class="mt-5">
                  <v-card outlined class="rounded-xl pa-2" :class="{'bg-active': computedConfigs.isActive}">
                    <v-switch
                      v-model="computedConfigs.isActive"
                      :hint="$t('welcome_message_hint')"
                      persistent-hint
                      class="ma-0 pa-0"
                      hide-details="auto"
                    >
                      <template #label>
                        <v-icon right :color="computedConfigs.isActive ? 'primary' : 'grey'" class="ml-2">
                          mdi-message-text-outline
                        </v-icon>
                        <span class="font-weight-bold" :class="computedConfigs.isActive ? 'primary--text' : 'black--text'">
                          {{ $t('send_sms') }}
                        </span>
                      </template>
                    </v-switch>
                  </v-card>
                </v-col>

                <!-- بخش تنظیمات وابسته -->
                <v-col cols="12" class="pa-0">
                  <v-expand-transition>
                    <div v-if="computedConfigs.isActive" class="pt-3">
                      <v-row no-gutters>
                        
                        <!-- فیلد دفعات ارسال -->
                        <v-col class="py-2 px-3" cols="12" md="6">
                          <v-text-field
                            v-model.number="computedConfigs.sendLimit"
                            type="number"
                            min="0"
                            class="rounded-lg"
                            dense
                            hide-details
                            prepend-inner-icon="mdi-repeat" 
                            :label="$t('send_limit_per_user')"
                            outlined
                            @input="debouncedSave"
                          />
                        </v-col>

                        <!-- بخش مدرن کد تخفیف -->
                        <v-col cols="12" class="px-3 mt-2">
                          <v-card outlined class="pa-4 rounded-xl discount-section">
                            <!-- سوییچ تخفیف -->
                            <v-switch
                              v-model="computedConfigs.hasDiscount"
                              hide-details
                              class="ma-0"
                              @change="debouncedSave"
                            >
                              <template #label>
                                <v-icon right color="orange" class="ml-2">mdi-ticket-percent-outline</v-icon>
                                <span class="font-weight-medium text-body-1">{{ $t('enable_discount_code') }}</span>
                              </template>
                            </v-switch>

                            <v-expand-transition>
                              <div v-if="computedConfigs.hasDiscount" class="mt-5">
                                <!-- فیلد افزودن کد تخفیف -->
                                <v-text-field
                                  v-model="newDiscountCode"
                                  :label="$t('add_new_discount_code')"
                                  dense
                                  outlined
                                  hide-details
                                  class="rounded-lg"
                                  prepend-inner-icon="mdi-tag-outline"
                                  @keyup.enter="addDiscountCode"
                                >
                                  <template v-slot:append>
                                    <v-btn
                                      small
                                      depressed
                                      icon
                                      class="btn-get-code rounded-md mt-n1 ma-0"
                                      @click="addDiscountCode"
                                    >
                                      <v-icon>mdi-plus</v-icon>
                                    </v-btn>
                                  </template>
                                </v-text-field>

                                <!-- لیست کدهای تخفیف با دیزاین تیکت -->
                                <div v-if="computedConfigs.discountCodes && computedConfigs.discountCodes.length" class="mt-4">
                                  <div class="d-flex flex-wrap" style="gap: 12px;">
                                    <v-chip
                                      v-for="code in visibleDiscountCodes"
                                      :key="code"
                                      class="modern-ticket-chip"
                                      color="white"
                                      text-color="primary"
                                      close
                                    outlined
                                      close-icon="mdi-close-circle"
                                      @click:close="removeDiscountCode(code)"
                                    >
                                      <span class="ticket-text">{{ code }}</span>
                                    </v-chip>
                                  </div>                                  
                                  <div v-if="computedConfigs.discountCodes.length > 6" class="mt-3 text-right">
                                    <v-btn
                                      small
                                      text
                                      color="primary"
                                      class="rounded-lg font-weight-bold"
                                      @click="showAllDiscounts = !showAllDiscounts"
                                    >
                                      {{ showAllDiscounts ? 'مشاهده کمتر' : `${persian(hiddenCodesCount)}+ کد تخفیف دیگر ` }}
                                      <v-icon right small>
                                        {{ showAllDiscounts ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                                      </v-icon>
                                    </v-btn>
                                  </div>
                                </div>

                                <!-- حالت خالی (Empty State) -->
                                <div v-else class="empty-ticket-state mt-4">
                                  <v-icon size="36" color="grey lighten-1">mdi-ticket-outline</v-icon>
                                  <div class="text-caption grey--text mt-2">{{ $t('no_discount_codes_added') }}</div>
                                </div>
                              </div>
                            </v-expand-transition>
                          </v-card>
                        </v-col>

                        <!-- تنظیمات پترن پیامک -->
                        <v-col class="pt-4 px-3" cols="12">
                          <sms-pattern-picker
                            v-model="selectedRow"
                            @reload="(e) => (rerender = e)"
                          />
                        </v-col>

                        <!-- متغیرهای پترن پیامک -->
                        <v-col
                          v-if="((selectedRow && Object.keys(selectedRow).length) || computedConfigs.smsType === 'campaign')"
                          cols="12"
                          class="px-3"
                        >
                          <pattern-inputs-generate
                            v-model="computedMessage"
                            :is-campaign="!!selectedRow?.campId || computedConfigs.smsType === 'campaign'"
                            :message="safeMessageForPattern"
                          />
                        </v-col>

                      </v-row>
                    </div>
                  </v-expand-transition>
                </v-col>

              </v-row>
            </div>
          </template>
        </help-info-wrapper>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import HelpInfo from "../../pages/qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "../../pages/qrland/components/helpAcordion/HelpInfoWrapper.vue";
import SmsPatternPicker from "./smsPatternPicker.vue";
import { mapState } from "vuex";
import PatternInputsGenerate from "@/view/components/fragments/patternInputsGenerate.vue";

export default {
  name: "customerClubSettings",

  components: {
    PatternInputsGenerate,
    SmsPatternPicker,
    HelpInfo,
    HelpInfoWrapper,
  },

  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "customClubSetting",
      sendSms: true,
      rerender: true,
      selectedRow: {},
      selectedCamp: false,
      newDiscountCode: "",
      saveTimeout: null,
      showAllDiscounts: false, // متغیر جدید برای مشاهده بیشتر/کمتر
    };
  },

  computed: {
    ...mapState("localstorage", ["createQrID"]),
    computedValue: {
      get() { return this.value; },
      set(val) { this.$emit("input", val); },
    },
    computedConfigs: {
      get() { return this.computedValue.configs || {}; },
      set(val) { this.$emit("input", val); },
    },
    computedMessage: {
      get() { return this.computedConfigs.message || {}; },
      set(val) {
        this.$set(this.computedConfigs, "message", val);
        this.emitUpdate();
      },
    },
    safeMessageForPattern() {
      if (!this.selectedRow || !Object.keys(this.selectedRow).length) {
        return { content: "", messages: { name: "", text: [], gap: [], type: [] } };
      }
      return this.selectedRow;
    },
     fields() {
      const regex = new RegExp(/data\d+/, "g");
      return this.selectedRow?.content?.match(regex).reduce((arr, curr) => {
        arr[curr] = {
          state: "data",
          text: "",
        };
        return arr;
      }, {});
    },
    visibleDiscountCodes() {
      const codes = this.computedConfigs.discountCodes || [];
      if (this.showAllDiscounts) return codes;
      return codes.slice(0, 6); 
    },
    hiddenCodesCount() {
      const codes = this.computedConfigs.discountCodes || [];
      return Math.max(0, codes.length - 6);
    },
  },

  watch: {
    computedMessage: {
      deep: true,
      handler() { this.$emit("input", this.computedValue); },
    },
    "$i18n.locale": {
      handler() {
        if (!this.value || !this.value.configs) {
          if (this.computedValue?.title === undefined || this.computedValue?.title === null || this.computedValue?.title === "") {
            this.computedValue.title = this.$t("customer_club_membership");
          } else {
            this.computedValue = { ...this.computedValue, title: this.$t("customer_club_membership") };
          }
        }
      },
      immediate: true,
      deep: true,
    },
    selectedRow: {
      deep: true,
      handler(val) {
        if (!val || !Object.keys(val).length) {
          this.emitUpdate();
          return;
        }
        const isCampaign = !!val.campId;
        // const isPattern = !!val.id;

        this.computedConfigs.patternId = isCampaign ? val.campId : val.id;
        this.computedConfigs.smsType = isCampaign ? "campaign" : "pattern";

        if (isCampaign) {
          this.$set(this.computedConfigs, "message", JSON.parse(JSON.stringify(val.messages || {})));
        } else {
          this.syncMessageWithPattern(val);
        }
        this.emitUpdate();
      },
    },
  },

  mounted() {
    const defaultMessage = {
      data1: { state: "userInfo", text: "name" },
      data2: { state: "userInfo", text: "lastName" },
    };

    if (!this.value || !this.value.configs) {
      this.computedValue = {
        title: this.$t("customer_club_membership"),
        description: "",
        configs: {
          patternId: 487,
          smsType: "pattern",
          isActive: true,
          message: defaultMessage,
          sendLimit: 1,
          hasDiscount: false,
          discountCodes: [],
        },
      };
    } else {
      if (this.value.configs.sendLimit === undefined) { this.$set(this.computedValue.configs, "sendLimit", 1); }
      if (this.value.configs.hasDiscount === undefined) { this.$set(this.computedValue.configs, "hasDiscount", false); }
      if (this.value.configs.discountCodes === undefined) { this.$set(this.computedValue.configs, "discountCodes", []); }

      if (this.value.configs.smsType === "pattern" && (!this.value.configs.message || !Object.keys(this.value.configs.message).length)) {
        this.computedValue = { ...this.computedValue, configs: { ...this.computedValue.configs, message: defaultMessage } };
      }
    }

    this.$nextTick(() => {
      this.selectedCamp = this.computedConfigs.smsType !== "pattern";
      this.selectedRow[this.computedConfigs.smsType === "pattern" ? "id" : "campId"] = this.computedConfigs.patternId;
    });
  },

  beforeDestroy() {
    if (this.saveTimeout) { clearTimeout(this.saveTimeout); }
  },

  methods: {
    syncMessageWithPattern(pattern) {
      const matches = (pattern.content || "").match(/data\d+/g) || [];
      const currentMessage = { ...this.computedConfigs.message };
      const newMessage = {};
      matches.forEach((key) => {
        if (!currentMessage.hasOwnProperty(key)) { newMessage[key] = { state: "data", text: "" }; }
      });
      this.$set(this.computedConfigs, "message", { ...currentMessage, ...newMessage });
    },

    debouncedSave() {
      this.emitUpdate();
      if (this.saveTimeout) { clearTimeout(this.saveTimeout); }
      this.saveTimeout = setTimeout(() => { this.senddiscountToBack(); }, 1500);
    },

    async senddiscountToBack() {
      if (!this.createQrID) { return; }
      const payload = {
        qr_id: this.createQrID,
        max_sms_count: this.computedConfigs.sendLimit || 1,
        discount_codes: this.computedConfigs.discountCodes,
        is_active_discounts: this.computedConfigs.hasDiscount,  
      };
      try {
        await this.$api.post(`${this.$payamakApi2}club-settings/update`, payload);
      } catch (error) {
        console.error("خطا در ذخیره تنظیمات تخفیف:", error);
      }
    },

    addDiscountCode() {
      const code = this.newDiscountCode.trim();
      if (code) {
        if (!this.computedConfigs.discountCodes) { this.$set(this.computedConfigs, "discountCodes", []); }
        if (!this.computedConfigs.discountCodes.includes(code)) {
          this.computedConfigs.discountCodes.unshift(code);
          this.emitUpdate();
          this.debouncedSave();
        }
        this.newDiscountCode = "";
      }
    },

    // تغییر متد ریموو: پیدا کردن ایندکس واقعی کد پاس داده شده
    removeDiscountCode(code) {
      const index = this.computedConfigs.discountCodes.indexOf(code);
      if (index > -1) {
        this.computedConfigs.discountCodes.splice(index, 1);
        this.emitUpdate();
        this.debouncedSave();
      }
    },

    emitUpdate() {
      this.$nextTick(() => { this.$emit("input", this.computedValue); });
    },

    resetToDefault() {
      this.computedMessage = {
        data1: { state: "userInfo", text: "name" },
        data2: { state: "userInfo", text: "lastName" },
      };
    },
  },
};
</script>
<style scoped>
tr { cursor: pointer !important; }
pre { font-family: "vazir", serif; color: unset !important; }

.bg-active {
  background-color: var(--v-primary-lighten10) !important;
  border-color: var(--v-primary-lighten1) !important;
  transition: all 0.3s ease;
}

.discount-section {
  background-color: #fafafa;
  border: 1px solid #eeeeee;
  transition: all 0.3s ease;
}

.discount-section:hover {
  border-color: #e0e0e0;
}

.ticket-text {
  padding-top: 2px;
}

.empty-ticket-state {
  border: 2px dashed #e0e0e0;
  border-radius: 12px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
}

.modern-ticket-chip {
  height: 36px !important;
  font-weight: 500;
  font-size: 13px;
  border-radius: 6px !important;
  
  background: transparent !important; 
  border: none !important;
  box-shadow: none !important;
  
  filter: none !important; 
  -webkit-mask: none !important;
  mask: none !important;
  
  isolation: isolate; 
  overflow: visible !important;
}

.modern-ticket-chip::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgb(208, 219, 252);
  border-radius: inherit;
  z-index: -1; 
  
  -webkit-mask: radial-gradient(circle at left, transparent 5px, black 5.5px) left,
                radial-gradient(circle at right, transparent 5px, black 5.5px) right;
  -webkit-mask-size: 51% 100%;
  -webkit-mask-repeat: no-repeat;
  mask: radial-gradient(circle at left, transparent 5px, black 5.5px) left,
        radial-gradient(circle at right, transparent 5px, black 5.5px) right;
  mask-size: 51% 100%;
  mask-repeat: no-repeat;
  
  filter: drop-shadow(2px 0 0 currentColor) 
          drop-shadow(-2px 0 0 currentColor) 
          drop-shadow(0 2px 0 currentColor) 
          drop-shadow(0 -2px 0 currentColor);
}

/* ۳. استایل خط‌چین و آیکون ضربدر */
.modern-ticket-chip ::v-deep .v-chip__close {
  border-right: 1.5px dashed currentColor;
  padding-right: 6px;
  margin-right: 6px;
  margin-left: 2px;
  color: inherit !important;
  opacity: 0.7;
}

.modern-ticket-chip ::v-deep .v-chip__close:hover {
  opacity: 1;
}
</style>
